var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_130_273)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 24,
    rx: 24,
    ry: 24,
    transform: "rotate(-180 28 24)",
    fill: "#096784"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5285 24.8968L30.6779 32.0337C30.7954 32.1521 30.9351 32.246 31.089 32.3102C31.2429 32.3743 31.408 32.4073 31.5748 32.4073C31.7415 32.4073 31.9066 32.3743 32.0606 32.3102C32.2145 32.246 32.3542 32.1521 32.4716 32.0337C32.7069 31.797 32.8389 31.4769 32.8389 31.1432C32.8389 30.8094 32.7069 30.4893 32.4716 30.2526L26.219 23.9368L32.4716 17.6842C32.7069 17.4475 32.8389 17.1274 32.8389 16.7937C32.8389 16.46 32.7069 16.1398 32.4716 15.9032C32.3546 15.7838 32.2151 15.6888 32.0612 15.6238C31.9072 15.5587 31.7419 15.5249 31.5748 15.5242C31.4076 15.5249 31.2423 15.5587 31.0884 15.6238C30.9344 15.6888 30.7949 15.7838 30.6779 15.9032L23.5285 23.04C23.4002 23.1583 23.2979 23.3018 23.2279 23.4616C23.1579 23.6214 23.1218 23.794 23.1218 23.9684C23.1218 24.1429 23.1579 24.3154 23.2279 24.4752C23.2979 24.635 23.4002 24.7785 23.5285 24.8968Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_130_273",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.227451 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_130_273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_130_273",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrowLeft);
export default __webpack_public_path__ + "static/media/btn-arrow-left.d93e607d7df97f9a872e72fe688e53b2.svg";
export { ForwardRef as ReactComponent };